import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { SanityContentDualImage } from '../../../../../graphql-types';
import * as styles from './dualImage.module.scss';
import { usePageContext } from '../../../../hooks/contexts/usePageContext';
import { Caption } from '../../../../components/2.0version/caption/Caption';

interface IDualImageProps {
  data: SanityContentDualImage;
}

export const DualImage = ({ data }: IDualImageProps) => {
  const { lang } = usePageContext();
  return (
    <div className={styles.wrapper}>
      {data.imageList?.map((img) => {
        const caption = img?._rawCaption?.[lang];
        const image = getImage(img?.image?.asset?.gatsbyImageData);
        return (
          image && (
            <div className={styles.imageWrapper}>
              <GatsbyImage image={image} alt={img?.alt ?? ''} className={styles.image} />
              {caption && <Caption caption={caption} />}
            </div>
          )
        );
      })}
    </div>
  );
};
